import { render, staticRenderFns } from "./MenuScheduler.vue?vue&type=template&id=5c2b89b6&scoped=true&"
import script from "./MenuScheduler.vue?vue&type=script&lang=js&"
export * from "./MenuScheduler.vue?vue&type=script&lang=js&"
import style0 from "./MenuScheduler.vue?vue&type=style&index=0&id=5c2b89b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b89b6",
  null
  
)

export default component.exports